"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _muiDatatables = _interopRequireDefault(require("mui-datatables"));

var _styles = require("@mui/styles");

var _styles2 = require("@mui/material/styles");

var _Table = require("./Table.style");

var Table = function Table(props) {
  var theme = (0, _styles2.createTheme)();
  return /*#__PURE__*/_react["default"].createElement(_Table.StyledTableWrapper, null, /*#__PURE__*/_react["default"].createElement(_styles.ThemeProvider, {
    theme: theme
  }, /*#__PURE__*/_react["default"].createElement(_muiDatatables["default"], props)));
};

var _default = Table;
exports["default"] = _default;